/// <reference path="../generated/MitgliedschaftAnlageResponseApi.d.ts"/>
/// <reference path="../generated/MitgliedschaftAnlagePersonResponseApi.d.ts"/>
import { AppUtils } from '../../utils/index';
import { AddressApi } from '../generated/PersonAddressApi';
import { AnredeArtApi } from '../generated/InterfacesAnredeArtApi';
import { PhoneApi } from '../generated/PersonPhoneApi';
import { AdacResultMessageApi } from '../generated/TypesAdacResultMessageApi';
/**
 * Api response data from the membership form application (1-stufigen).
 * This model is an exception, it is only needed for serialization of MglCustomerModel.
 * Usually you would use AnlageResponseApi directly
 * @see MglCustomerModel
 */
export class MglApiResponseDataModel implements AnlageResponseApi {
	private partner: AnlagePersonResponseApi;
	private kinder: AnlagePersonResponseApi[];
	private jungeErwachsene: AnlagePersonResponseApi[];
	private anrede: AnredeArtApi;
	private geburtsdatum: string;
	private telefon: PhoneApi;
	private telGesch: PhoneApi;
	private email: string;
	private message: AdacResultMessageApi;
	private token: string;
	private nachname: string;
	private vorname: string;
	private anschrift: AddressApi;
	private mitgliedsnummer: string;
	private title: string;

	get Partner(): AnlagePersonResponseApi {
		return this.partner;
	}
	set Partner(value: AnlagePersonResponseApi) {
		this.partner = value;
	}

	get Kinder(): AnlagePersonResponseApi[] {
		return this.kinder;
	}
	set Kinder(value: AnlagePersonResponseApi[]) {
		this.kinder = value;
	}

	get JungeErwachsene(): AnlagePersonResponseApi[] {
		return this.jungeErwachsene;
	}
	set JungeErwachsene(value: AnlagePersonResponseApi[]) {
		this.jungeErwachsene = value;
	}

	get Anrede(): AnredeArtApi {
		return this.anrede;
	}
	set Anrede(value: AnredeArtApi) {
		this.anrede = value;
	}

	get Titel(): string {
		return this.title;
	}

	set Titel(value: string) {
		this.title = value;
	}

	get Geburtsdatum(): string {
		return this.geburtsdatum;
	}
	set Geburtsdatum(value: string) {
		this.geburtsdatum = value;
	}

	get Telefon(): PhoneApi {
		return this.telefon;
	}
	set Telefon(value: PhoneApi) {
		this.telefon = value;
	}

	get TelGesch(): PhoneApi {
		return this.telGesch;
	}
	set TelGesch(value: PhoneApi) {
		this.telGesch = value;
	}

	get Email(): string {
		return this.email;
	}
	set Email(value: string) {
		this.email = value;
	}

	get Message(): AdacResultMessageApi {
		return this.message;
	}
	set Message(value: AdacResultMessageApi) {
		this.message = value;
	}

	get Token(): string {
		return this.token;
	}
	set Token(value: string) {
		this.token = value;
	}

	get Nachname(): string {
		return this.nachname;
	}
	set Nachname(value: string) {
		this.nachname = value;
	}

	get Vorname(): string {
		return this.vorname;
	}
	set Vorname(value: string) {
		this.vorname = value;
	}

	get Anschrift(): AddressApi {
		return this.anschrift;
	}
	set Anschrift(value: AddressApi) {
		this.anschrift = value;
	}

	get Mitgliedsnummer(): string {
		return this.mitgliedsnummer;
	}
	set Mitgliedsnummer(value: string) {
		this.mitgliedsnummer = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * Creates a new MglApiResponseDataModel object and copies the values from the provided data object (or other MglApiResponseData model) to the created MglApiResponseDataModel.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MglApiResponseDataModel {
		return AppUtils.Helper.createFromMap(dataObject, MglApiResponseDataModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'anschrift') {
				return AddressApi.createFromObject(value);
			} else {
				return value;
			}
		});
	}
}